module.exports = "/static/media/inbox.169e9e29.svg";